<template>
  <el-dialog
    custom-class="certificate-query-dialog"
    :visible.sync="visible"
    title="证书查询"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="hide"
  >
    <el-form
      :model="formModel"
      :rules="rules"
      inline
      ref="formRef"
      @submit.native.prevent
    >
      <el-form-item label="证书编号" prop="number">
        <el-input
          v-model="formModel.number"
          style="width: 300px"
          placeholder="请输入"
        ></el-input>
        <p v-if="error" class="error">{{ error }}</p>
      </el-form-item>

      <el-form-item label=" ">
        <el-button type="primary" @click="onSearch"> 查询 </el-button>
      </el-form-item>
    </el-form>

    <template v-if="result">
      <div class="certificate-query-result">查询结果</div>

      <el-form label-width="120px" label-position="left">
        <el-form-item label="课程" prop="name">
          {{ result.courseTitle }}
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          {{ result.realname }}
        </el-form-item>
        <el-form-item label="证件号" prop="name">
          {{ result.idcardNo }}
        </el-form-item>
        <el-form-item label="颁发日期" prop="name">
          {{
            result.issueTime ? dayjs(result.issueTime).format("YYYY-MM-DD") : ""
          }}
        </el-form-item>
        <el-form-item label="颁发单位" prop="name">
          {{ result.issueOrgList ? result.issueOrgList.join("，") : "" }}
        </el-form-item>
        <el-form-item label="学时" prop="name" v-if="!!result.isOpenClassHour">
          {{ result.classHour + '学时' }}
        </el-form-item>
      </el-form>
    </template>
  </el-dialog>
</template>

<script>
import { certificateCheck } from "@/api/course";
import dayjs from "dayjs";

export default {
  name: "CertificateQueryDialog",
  data() {
    return {
      dayjs,
      visible: false,
      formModel: {
        number: "",
      },
      rules: {
        number: [
          { required: true, message: "证书编号不能为空", trigger: "blur" },
        ],
      },
      result: null,

      error: "",
    };
  },
  watch: {
    "formModel.number": {
      handler() {
        this.error = "";
      },
    },
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.result = null;
      this.$refs.formRef.resetFields();
    },
    onSearch() {
      this.$refs.formRef.validate(async (res) => {
        if (!res) return;

        const { code, data, msg } = await certificateCheck(
          this.formModel.number
        );

        if (code === 500014) {
          // 清空查询结果
          this.result = null;
          this.error = msg;
          return;
        }

        this.result = data;
      });
    },
  },
};
</script>

<style lang="scss">
.certificate-query-dialog {
  &.el-dialog {
    background: #171f30;
    border: 1px solid #046bde;
  }

  .el-dialog__header {
    padding: 60px 60px 20px 60px;
  }

  .el-dialog__title {
    font-weight: 600;
    font-size: 30px;
    color: #ffffff;
  }

  .el-dialog__body {
    padding: 0 60px 60px 60px;
  }

  .el-input__inner {
    background-color: transparent;
    border: 1px solid #046bde;
    border-radius: 20px;
    color: #fff;

    &::placeholder {
      color: #909399;
    }
  }

  .el-form-item__label {
    color: #fff;
  }

  .el-form-item__content {
    color: #fff;
  }
}

.certificate-query-result {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;

  &::before {
    content: "";
    margin-right: 30px;
    width: 196px;
    height: 1px;
    background: #046bde;
  }

  &::after {
    content: "";
    margin-left: 30px;
    width: 196px;
    height: 1px;
    background: #046bde;
  }
}

.error {
  color: #f56c6c;
  font-size: 12px;
}
</style>
